import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const SpaDetailsRow = styled.div<{ isWrap?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 10px;

  ${({ isWrap }) =>
    isWrap &&
    `
    flex-direction: column;
    flex-wrap: wrap;
  `}

  ${media.xl`
    flex-direction: row;
  `}
`;

export const SpaDetailsCol = styled.div`
  flex-direction: column;
  width: 100%;
`;

export const SpaGuestName = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  text-transform: uppercase;
  margin-top: 26px;
  margin-bottom: 8px;
  font-size: 14px;

  ${media.xl`
    font-size: 18px;
  `}
`;
